// Components
import { ClearFilters } from "Components/Users/ClearFilters";
// Hooks
import useDateRange from "hooks/useDateRange";
// Store utils
import { useDispatch } from "react-redux";
// External Tools
import { sentenceCase } from "change-case";
import { notificationsRecepientsDateCreatedUpdatedArchivedDeletedAction, protocolsDateCreatedUpdatedArchivedDeletedAction } from "store/filters/reducer.actions";

// Defining the DateProps interface for the Date component.
interface DateProps {
  name: string;
  isApplied: boolean;
  date: any;
}
// Defining the Date component as a functional component that receives DateProps.
export const DateRecieved: React.FC<DateProps> = ({ name, isApplied , date}) => {
  const dispatch = useDispatch(); // Initializing the Redux dispatch function.
  const { getSingleDateOption } = useDateRange(); // Using the useDateRange hook to get the getDateOption function.

  // Defining a function to reset the filter when ClearFilters is clicked.
  const resetFilter = () => {
    dispatch(notificationsRecepientsDateCreatedUpdatedArchivedDeletedAction(""));
  };

  if (!isApplied) {
    return null;
  }

  if (date === "Invalid date") {
    dispatch(notificationsRecepientsDateCreatedUpdatedArchivedDeletedAction(""));
  }

  return (
    <div className="flex flex-wrap justify-center items-center  relative gap-1 p-1 rounded-lg bg-primary/[0.08]">
      <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 relative px-1 pt-1.5 pb-2">
        <p className="flex-grow-0 flex-shrink-0 text-sm text-center text-secondaryMid">
          {sentenceCase(name)} : {getSingleDateOption( date)}
        </p>
      </div>
      <ClearFilters handleClick={resetFilter} />
    </div>
  );
};
